import { Glass, Dot, ScreenLabel, DisplayText, BodyText } from "../../components/mobile/primitives";

function JourneyNotificationsScreen() {
  return (
    <div style={{ padding: "8px 16px 0", display: "flex", flexDirection: "column", gap: 10 }}>
      {/* Greeting — same as home */}
      <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <ScreenLabel>Sun, Mar 2</ScreenLabel>
        <DisplayText size={24}>Good morning</DisplayText>
        <DisplayText size={17} color="#3A4A3D">
          Sverre
        </DisplayText>
      </div>

      {/* Dimmed background content */}
      <div style={{ opacity: 0.3, pointerEvents: "none" }}>
        <Glass style={{ padding: "10px 12px" }}>
          <BodyText size={10} weight={600}>
            Today's Trackers
          </BodyText>
        </Glass>
      </div>

      {/* Modal overlay */}
      <div
        style={{
          background: "rgba(254,253,251,0.95)",
          border: "1px solid rgba(255,255,255,0.60)",
          borderRadius: 24,
          padding: "20px 18px",
          backdropFilter: "blur(20px)",
          boxShadow: "0 16px 48px -12px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.8)",
          textAlign: "center",
        }}
      >
        {/* Bell icon */}
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            background: "rgba(91,122,102,0.10)",
            border: "1px solid rgba(91,122,102,0.22)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 12px",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--color-kin-green-soft)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
        </div>

        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            padding: "3px 10px",
            borderRadius: 20,
            background: "rgba(91,122,102,0.12)",
            border: "1px solid rgba(91,122,102,0.22)",
            marginBottom: 8,
          }}
        >
          <Dot color="var(--color-kin-green-soft)" size={6} />
          <BodyText size={8} color="var(--color-kin-green-soft)" weight={700}>
            First log completed
          </BodyText>
        </div>

        <DisplayText size={18}>Enable reminders?</DisplayText>
        <BodyText
          size={10}
          color="var(--color-kin-muted)"
          weight={400}
          style={{ marginTop: 6, lineHeight: 1.55, padding: "0 8px" }}
        >
          You already logged once today. Want one quiet reminder at your chosen meal windows to keep
          the streak going?
        </BodyText>

        {/* Example notification */}
        <div
          style={{
            background: "rgba(0,0,0,0.04)",
            borderRadius: 12,
            padding: "8px 12px",
            marginTop: 14,
            display: "flex",
            alignItems: "center",
            gap: 8,
            textAlign: "left",
          }}
        >
          <Dot color="var(--color-kin-gold)" size={8} />
          <div>
            <BodyText size={8} color="var(--color-kin-muted)" weight={600}>
              Preview
            </BodyText>
            <BodyText size={9.5} weight={600}>
              Lunch check-in in 30 sec?
            </BodyText>
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 16 }}>
          <div
            style={{
              background: "var(--color-kin-green-soft)",
              borderRadius: 14,
              padding: "11px 0",
              textAlign: "center",
            }}
          >
            <BodyText size={11} color="#fff" weight={700}>
              Allow notifications
            </BodyText>
          </div>
          <div style={{ padding: "8px 0", textAlign: "center" }}>
            <BodyText size={10} color="var(--color-kin-muted)" weight={600}>
              Not now
            </BodyText>
          </div>
        </div>
      </div>
    </div>
  );
}

export { JourneyNotificationsScreen };
